export const getInitialState = () => ({
	counters: null,
	generalErrors: [],
	features: null,
	isVerificationInProgress: false
});
